import { LitElement, html } from 'lit';
import { styles } from './css';
import { logErrorToSentry } from '../../../../helpers/helpers';
import '@Root/lib/lit-3form-block/components/cta-text';

import {
  SHARED_CLASSES,
  SHARED_ELEMENTS,
} from '@Root/lib/lit-3form-block/styles.js';

import { LIT_CSS_VARIABLES, GRID_LAYOUT } from '@Root/lib/lit-styles.js';
export class EstimateBarrel extends LitElement {
  static get properties() {
    return {
      content: { type: Object },
      expanded: { type: Boolean },
      _currentSelectionSPREE: { type: Object },
      _displayPrice: { type: String },
    };
  }

  static get styles() {
    return [
      LIT_CSS_VARIABLES,
      SHARED_ELEMENTS,
      SHARED_CLASSES,
      GRID_LAYOUT,
      styles,
    ];
  }

  constructor() {
    super();

    this.content = JSON.parse(this.getAttribute('content'));
    this._currentSelectionSPREE = {};
    this._displayPrice = '';
  }

  async connectedCallback() {
    super.connectedCallback();
    this.setCurrentSelectionSPREE();
  }

  render() {
    return html`
      <div class="barrel-wrapper-expanded">
        <div class="barrel-header">
          <h3>${this.barrelTitle}</h3>
        </div>
        <div>
          <p class="barrel-text">
            Chat with our Customer Service team if you:
          </p>
          <ul class="no-bullets">
            <li>
              Need a different surface finish, gauge, edge finish, diffusion
              layer, etc. than what is listed.
            </li>
            <li>
              Plan to backlight the panel or adhere it directly to a wall.
            </li>
            <li>
              Are unsure which gauge is appropriate for your application. Note
              that Varia panels have varied degrees of deflection.
            </li>
          </ul>
          <p class="barrel-text">
            Shipping is only available within the US and varies based on the
            quantity of panels ordered and the ship to location.
          </p>
          <p class="barrel-text">
            All sales are final.
          </p>
        </div>

        ${this.content.gauge
          ? html`
              <div class="material-row-wrapper">
                <span class="material-row-header">
                  <p class="barrel-heavy-text">Gauge</p>
                </span>
                <span class="material-row-value">
                  <p class="row-content-text">
                    ${this.content.gauge}
                  </p>
                </span>
              </div>
            `
          : html``}

        <div class="material-row-wrapper">
          <span class="material-row-header">
            <p class="barrel-heavy-text">Panel Size</p>
          </span>
          <span class="material-row-value">
            <p class="row-content-text">
              48" x 96" panel
            </p>
          </span>
        </div>

        <div class="material-row-wrapper">
          <span class="material-row-header">
            <p class="barrel-heavy-text">Finish</p>
          </span>
          <span class="material-row-value">
            <p class="row-content-text">
              Sandstone Finish (both sides)
            </p>
          </span>
        </div>

        ${this.humanizedEdgeFinish
          ? html`
              <div class="material-row-wrapper">
                <span class="material-row-header">
                  <p class="barrel-heavy-text">Edge Finish</p>
                </span>
                <span class="material-row-value">
                  <p class="row-content-text">
                    ${this.humanizedEdgeFinish}
                  </p>
                </span>
              </div>
            `
          : html``}
        ${this.content.lead_time
          ? html`
              <div class="material-row-wrapper">
                <span class="material-row-header">
                  <p class="barrel-heavy-text">Lead Time</p>
                </span>
                <span class="material-row-value">
                  <p class="row-content-text">
                    ${this.content.lead_time}
                  </p>
                </span>
              </div>
            `
          : html``}
        ${this.panelQuantity
          ? html`
              <div class="material-row-wrapper">
                <span class="material-row-header">
                  <p class="barrel-heavy-text">Quantity</p>
                </span>
                <span class="material-row-value">
                  <p class="row-content-text">
                    ${this.panelQuantity}
                  </p>
                </span>
              </div>
            `
          : html``}
        <div class="material-row-wrapper total">
          <span class="material-row-header">
            <p class="barrel-heavy-text">Estimated Total</p>
          </span>
          <span class="material-row-value">
            <p class="row-content-text">
              ${this._displayPrice}
            </p>
            <p class="row-content-text line-space-above">
              Taxes and shipping not included
            </p>
          </span>
          <div class="total-disclaimer">
            <p>
              All sales are final.
            </p>
            <p class="line-space-above">
              This document is for informational purposes only.
              <br />
              Prices are subject to change.
            </p>
            <p class="line-space-above">
              If you have any questions about your order please contact your
              Materials Consultant or chat with a Customer Service Rep.
            </p>
            <p class="line-space-above">
              Have terms with us? Please contact us at
              customer.support@3-form.com
            </p>
          </div>
        </div>
      </div>
    `;
  }

  async setCurrentSelectionSPREE() {
    if (!window.SpreeAPI) return;
    const spreeHost = window.SpreeAPI.host;
    const externalId = this.content.spree_product_id;

    const url = `${spreeHost}/api/v2/storefront/products/${externalId}`;
    const options = {
      method: 'GET',
      headers: { Accept: 'application/vnd.api+json' },
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      this._currentSelectionSPREE = data?.data?.attributes || null;
      this._displayPrice = this.formattedTotalPrice;
      this.requestUpdate();
    } catch (error) {
      logErrorToSentry(error);
    }
  }

  get headerString() {
    return this.content.headerStr || '';
  }

  get barrelTitle() {
    const titleStr = this.content.headerStr || '';
    const panelStr = '48"X 96" panel';
    return `${titleStr} ${panelStr}`.trim();
  }

  get humanizedEdgeFinish() {
    let edgeFinishString = this.content.edge_finish || '';
    return edgeFinishString.charAt(0).toUpperCase() + edgeFinishString.slice(1);
  }

  get panelQuantity() {
    return this.content.quantity || 1;
  }

  get formattedTotalPrice() {
    const price = this._currentSelectionSPREE?.price || null;
    const totalPriceNumber =
      this.panelQuantity * (Math.round(parseFloat(price) * 100) / 100);
    const formattedTotal = totalPriceNumber.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return formattedTotal;
  }
}
customElements.define('estimate-barrel', EstimateBarrel);
